import React, { useState } from 'react';
import { Switch as AntdSwitch, Space } from 'antd';

const Toggle = () => {
  const [value, setValue] = useState(false);

  const toggleSwitch = () => {
    setValue(!value);
  };

  return (
    <Space className='flex flex-col'>
      <div>
        <AntdSwitch
          checked={value}
          onChange={toggleSwitch}
          style={{ background: value ? 'rgba(43, 207, 231, 1)' : null }}
        />
        {/* <span style={{ marginLeft: '8px' }}>On</span> */}
      </div>
      {/* <div>
        <AntdSwitch
          checked={!value}
          onChange={toggleSwitch}
          style={{ background: !value ? 'rgba(43, 207, 231, 1)' : null }}
        />
        <span style={{ marginLeft: '8px' }}>Off</span>
      </div> */}
    </Space>
  );
};

export default Toggle;
